<template>
	<div class="candidate">
		<section class="flex-r flex-ctr head">
			<van-image class="head-banner" :src="GE.banner" />
			<van-image class="head-banner-bottom" :src="GE.bannerBottom" />
		</section>
		<section class="wrap flex-c">
			<!-- <div class="flex-self-ctr title">{{candidateMsg.title}}</div> -->
			<div v-html="candidateMsg.answer_text" class="content"></div>
			<!-- <van-button class="vote-btn flex-self-ctr" type="primary" :loading="submitLoading" loading-text="投票中" @click="vote_click">投票</van-button> -->
		</section>
	</div>
</template>


<script type="text/javascript">
	import { mapState } from 'vuex'
	export default {
		data () {
			return {
				submitLoading: false,
				GE: {
					banner: require('@/assets/banner.png'),
					bannerBottom: require('@/assets/banner-bottom.png')
				}
			}
		},

		mounted () {
			this.init();
		},
		computed: mapState({
			candidateMsg: state => state.Vote.candidateMsg,
			voteMsg: state => state.Vote.voteMsg,
		}),
		methods: {
			init () {
				this.$toast.loading({
					message: '加载中...',
					forbidClick: true,
					loadingType: 'spinner'
				});
				this.submitLoading = false;
				this.$store.dispatch('getCandidateApi', this.$route.query.id || 0).then(() => {
					const shareLink = window.location.href;
					this.wx_share({
						title: this.candidateMsg.title,
						link: shareLink,
						imgUrl: this.candidateMsg.img_url
					});
					this.$toast.clear();
				}).catch(() => {
					this.$toast.clear();
				});
			},
			vote_click () {
				this.$toast.loading({
					message: '投票中...',
					forbidClick: true,
					loadingType: 'spinner'
				});
				this.submitLoading = true;
				this.$store.dispatch('voteApi', this.$route.query.id || 0).then(() => {
					this.$toast.success({
						duration: 2000, // 持续展示 toast
						forbidClick: true,
						message: '投票成功'
					});
					this.submitLoading = false;
					// this.init();
				}).catch(e => {
					this.submitLoading = false;
					// eslint-disable-next-line no-console
					console.log(e)
				})
			}
		}
	}
</script>

<style lang="scss" scpoped>
	.candidate::before {
		content: "";
		position: absolute;
		left: 0;
		width: 2rem;
		top: 0;
		bottom: 0;
		background: url("../assets/left-bac.png") repeat-y;
		background-size: 100% auto;
		overflow: hidden;
		z-index: 1;
	}
	.candidate::after {
		content: "";
		position: absolute;
		right: 0;
		width: 2rem;
		top: 0;
		bottom: 0;
		background: url("../assets/right-bac.png") repeat-y;
		background-size: 100% auto;
		overflow: hidden;
		z-index: 1;
	}
	.title {
		font-weight: 600;
		font-size: 0.34rem;
	}
	.content {
		margin: 10px 0;
		font-size: 0.3rem;
		position: relative;
		z-index: 2;
		img {
			max-width: 100%;
			width: inherit;
		}
		table {
			max-width: 100%;
			width: inherit;
		}
	}
	.candidate {
		width: 100%;
		min-height: 100vh;
		background-color: #005296;
		color: #fff;
		font-size: 20px;
		position: relative;
		.head {
			position: relative;
			overflow: hidden;
			.head-banner {
				min-width: 16rem;
			}
			.head-banner-bottom {
				width: 100%;
				min-width: 300px;
				position: absolute;
				bottom: 0;
				transform: translateY(17.89%);
			}
		}
		.wrap {
			padding: 0 20px;
			max-width: 1200px;
			margin: 0 auto;
			.title {
				padding: 20px 0;
			}
			.content {
				margin-bottom: 50px;
			}
			.vote-btn {
				width: 300px;
				margin-bottom: 30px;
			}
		}
	}
</style>